import React from "react";
import { useStore } from "store";
import { StoreType } from "store/types";

export function OrientationChangeLoader() {
  const { isOrientationChanging }: StoreType = useStore();

  if (!isOrientationChanging) return null;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: orientationLoaderStyles }} />
      <div className="orientation-loader-overlay">
        <div className="orientation-loader-content">
          <div className="orientation-loader-icon">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Phone/page rectangle that rotates */}
              <rect
                className="orientation-loader-rect"
                x="12"
                y="10"
                width="22"
                height="32"
                rx="3"
                stroke="#EE4360"
                strokeWidth="2.5"
                fill="rgba(238, 67, 96, 0.08)"
              />
              {/* Curved arrow body */}
              <path
                className="orientation-loader-arrow"
                d="M42 16 C52 16, 56 24, 56 32 C56 40, 52 48, 42 48"
                stroke="#EE4360"
                strokeWidth="2.5"
                fill="none"
                strokeLinecap="round"
              />
              {/* Arrowhead triangle */}
              <polygon className="orientation-loader-arrow" points="44,42 38,48 44,54" fill="#EE4360" />
            </svg>
          </div>
          <span className="orientation-loader-text">Adjusting orientation...</span>
        </div>
      </div>
    </>
  );
}

const orientationLoaderStyles = `
  @keyframes orientationFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes orientationRotate {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(90deg); }
    100% { transform: rotate(90deg); }
  }

  @keyframes orientationPulse {
    0%, 100% { opacity: 0.6; }
    50% { opacity: 1; }
  }

  .orientation-loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9998;
    animation: orientationFadeIn 0.2s ease-out;
  }

  .orientation-loader-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .orientation-loader-icon {
    animation: orientationPulse 1.5s ease-in-out infinite;
  }

  .orientation-loader-rect {
    transform-origin: 22px 25px;
    animation: orientationRotate 1.5s ease-in-out infinite;
  }

  .orientation-loader-arrow {
    animation: orientationPulse 1.5s ease-in-out infinite;
  }

  .orientation-loader-text {
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #4b5563;
    letter-spacing: -0.02em;
    animation: orientationPulse 1.5s ease-in-out infinite;
  }
`;
